<h3>Férias Especiais Judiciais</h3>
<a href="#" class="sr-only">Férias Especiais Judiciais</a>

<ng-container *ngIf="exercicioSelecionado as exercicio">
    <app-cabecalho-funcional [exercicioSelecionado]="exercicio" [exibirPeriodoProgramacaoDisponivel]="false" [exibirTipoPeriodoAquisitivo]="true"></app-cabecalho-funcional>
</ng-container>

<form [formGroup]="formulario" (ngSubmit)="concluir()" novalidate>
    <div class="row">
        <div class="col-12 col-lg-6 mt-2">
            <div #dsgovInput class="br-input" [class.danger]="campoInvalido('numeroProcesso')">
                <label for="numero-processo-judicial">Número do processo judicial (Obrigatório)</label>
                <input id="numero-processo-judicial" type="text" formControlName="numeroProcesso" maxlength="50" aria-describedby="numero-processo-judicial-ajuda" (input)="registrarAlteracao()" />
                <p id="numero-processo-judicial-ajuda" class="text-base mt-1">Informe até 50 caracteres, sem seis ou mais dígitos consecutivos iguais.</p>
                <p class="feedback danger" role="alert" *ngIf="campoInvalido('numeroProcesso') && !campoObrigatorioNaoInformado('numeroProcesso')">Informe um número de processo judicial válido, com até 50 caracteres e sem seis ou mais dígitos consecutivos iguais.</p>
                <p class="mt-1" *ngIf="campoObrigatorioNaoInformado('numeroProcesso')">
                    <span class="feedback danger" role="alert">
                        <i class="fas fa-times-circle" aria-hidden="true"></i>
                        Campo obrigatório
                    </span>
                </p>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-12 mt-2">
            <div #dsgovTextarea class="br-textarea" [class.danger]="campoInvalido('sentencaJudicial')">
                <label for="sentenca-judicial">Descrição resumida da sentença (Obrigatório)</label>
                <textarea id="sentenca-judicial" formControlName="sentencaJudicial" rows="6" maxlength="300" aria-describedby="sentenca-judicial-contador" (input)="registrarAlteracao()"></textarea>
                <p id="sentenca-judicial-contador" class="text-base mt-1" aria-live="polite">{{ formulario.controls.sentencaJudicial.value.length }} de 300 caracteres</p>
                <p class="feedback danger" role="alert" *ngIf="campoInvalido('sentencaJudicial') && !campoObrigatorioNaoInformado('sentencaJudicial')">A descrição resumida da sentença deve conter entre 10 e 300 caracteres.</p>
                <p class="mt-1" *ngIf="campoObrigatorioNaoInformado('sentencaJudicial')">
                    <span class="feedback danger" role="alert">
                        <i class="fas fa-times-circle" aria-hidden="true"></i>
                        Campo obrigatório
                    </span>
                </p>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-12 col-lg-2 mt-2">
            <div #dsgovInput class="br-input" [class.danger]="campoInvalido('quantidadeDias')">
                <label for="quantidade-dias-judicial">Quantidade de Dias (Obrigatório)</label>
                <input id="quantidade-dias-judicial" type="number" min="1" max="90" step="1" formControlName="quantidadeDias" (input)="validarInputQuantidadeDias($event)" />
                <p class="feedback danger" role="alert" *ngIf="campoInvalido('quantidadeDias') && !campoObrigatorioNaoInformado('quantidadeDias')">Informe uma quantidade inteira entre 1 e 90 dias.</p>
                <p class="mt-1" *ngIf="campoObrigatorioNaoInformado('quantidadeDias')">
                    <span class="feedback danger" role="alert">
                        <i class="fas fa-times-circle" aria-hidden="true"></i>
                        Campo obrigatório
                    </span>
                </p>
            </div>
        </div>

        <div class="col-12 col-lg-3 mt-2">
            <div #dsgovInput class="br-input" [class.danger]="campoInvalido('quantidadeMaximaParcelas')">
                <label for="quantidade-maxima-parcelas">Máximo de Parcelas Férias</label>
                <p-dropdown inputId="quantidade-maxima-parcelas" [options]="quantidadeMaximaParcelas" formControlName="quantidadeMaximaParcelas" placeholder="Selecione" (onChange)="registrarAlteracao()"></p-dropdown>
                <p class="feedback danger" role="alert" *ngIf="campoInvalido('quantidadeMaximaParcelas') && !campoObrigatorioNaoInformado('quantidadeMaximaParcelas')">
                    Selecione um valor entre 1 e
                    {{ limiteQuantidadeMaximaParcelas }} parcelas.
                </p>
                <p class="mt-1" *ngIf="campoObrigatorioNaoInformado('quantidadeMaximaParcelas')">
                    <span class="feedback danger" role="alert">
                        <i class="fas fa-times-circle" aria-hidden="true"></i>
                        Campo obrigatório
                    </span>
                </p>
            </div>
        </div>

        <div class="col-12 col-lg-2 mt-2">
            <div #dsgovInput class="br-input" [class.danger]="campoInvalido('periodoAquisitivo')">
                <label for="periodo-aquisitivo-judicial">Tipo de Aquisição de Férias</label>
                <p-dropdown inputId="periodo-aquisitivo-judicial" [options]="opcoesPeriodoAquisitivo" optionLabel="label" optionValue="value" formControlName="periodoAquisitivo" placeholder="Selecione" (onChange)="alterarPeriodoAquisitivo($event.value)"></p-dropdown>
                <p class="feedback danger" role="alert" *ngIf="campoInvalido('periodoAquisitivo') && !campoObrigatorioNaoInformado('periodoAquisitivo')">Selecione Ano Civil ou Período Aquisitivo.</p>
                <p class="mt-1" *ngIf="campoObrigatorioNaoInformado('periodoAquisitivo')">
                    <span class="feedback danger" role="alert">
                        <i class="fas fa-times-circle" aria-hidden="true"></i>
                        Campo obrigatório
                    </span>
                </p>
            </div>
        </div>

        <div class="col-12 col-lg-2 mt-2">
            <label id="inicio-periodo-programacao-label">Início Período de Programação</label>
            <p class="mb-0" id="inicio-periodo-programacao" aria-labelledby="inicio-periodo-programacao-label">
                {{ exercicioSelecionado?.dataInicioPeriodoProgramacao ?? "" | dataFormatada }}
            </p>
            <p class="mt-1" role="status" aria-live="polite" *ngIf="calculandoPeriodoProgramacao">Calculando o período de programação...</p>
            <p class="feedback danger" role="alert" *ngIf="erroCalculoPeriodoProgramacao">Não foi possível calcular o período de programação. Tente novamente.</p>
        </div>

        <div class="col-12 col-lg-3 mt-2">
            <div #dsgovInput class="br-input" [ngClass]="{ danger: campoInvalido('dataFimPeriodoProgramacao'), 'br-datetimepicker': extraordinario }">
                <label id="fim-periodo-programacao-label" [attr.for]="extraordinario ? 'fim-periodo-programacao' : null">Fim Período de Programação{{ extraordinario ? " (Obrigatório)" : "" }}</label>
                <p *ngIf="!extraordinario" class="mb-0" id="fim-periodo-programacao" aria-labelledby="fim-periodo-programacao-label">
                    {{ formulario.controls.dataFimPeriodoProgramacao.value | dataFormatada }}
                </p>
                <ng-container *ngIf="dataMinimaFimPeriodoProgramacao as dataMinima; else calendarioSemDataMinima">
                    <p-calendar *ngIf="extraordinario" inputId="fim-periodo-programacao" [showIcon]="true" icon="fas fa-calendar-alt" [monthNavigator]="true" [yearNavigator]="true" yearRange="2023:2100" dateFormat="dd/mm/yy" placeholder="dd/mm/aaaa" formControlName="dataFimPeriodoProgramacao" [minDate]="dataMinima" [showOtherMonths]="false" [disabled]="calculandoPeriodoProgramacao" (onSelect)="registrarAlteracao()" (onInput)="registrarAlteracao()" (onBlur)="registrarAlteracao()"></p-calendar>
                </ng-container>
                <ng-template #calendarioSemDataMinima>
                    <p-calendar *ngIf="extraordinario" inputId="fim-periodo-programacao" [showIcon]="true" icon="fas fa-calendar-alt" [monthNavigator]="true" [yearNavigator]="true" yearRange="2023:2100" dateFormat="dd/mm/yy" placeholder="dd/mm/aaaa" formControlName="dataFimPeriodoProgramacao" [showOtherMonths]="false" [disabled]="calculandoPeriodoProgramacao" (onSelect)="registrarAlteracao()" (onInput)="registrarAlteracao()" (onBlur)="registrarAlteracao()"></p-calendar>
                </ng-template>
                <p class="feedback danger" role="alert" *ngIf="campoInvalido('dataFimPeriodoProgramacao') && !campoObrigatorioNaoInformado('dataFimPeriodoProgramacao')">Informe uma data válida posterior ao início do período de programação.</p>
                <p class="mt-1" *ngIf="campoObrigatorioNaoInformado('dataFimPeriodoProgramacao')">
                    <span class="feedback danger" role="alert">
                        <i class="fas fa-times-circle" aria-hidden="true"></i>
                        Campo obrigatório
                    </span>
                </p>
            </div>
        </div>
    </div>

    <div class="row mt-2">
        <div class="col-12 col-lg-9">
            <p-checkbox [binary]="true" label="Declaro que a decisão judicial está registrada no SIGEPE Ação Judicial." formControlName="declaracaoAcaoJudicial" (onChange)="registrarAlteracao()">
                <ng-template pTemplate="icon">
                    <span class="fas fa-check"></span>
                </ng-template>
            </p-checkbox>
            <p class="mt-1" *ngIf="campoObrigatorioNaoInformado('declaracaoAcaoJudicial')">
                <span class="feedback danger" role="alert">
                    <i class="fas fa-times-circle" aria-hidden="true"></i>
                    Campo obrigatório
                </span>
            </p>
        </div>
        <div class="col-12 col-lg-3">
            <p-checkbox [binary]="true" formControlName="extraordinario" [disabled]="calculandoPeriodoProgramacao" (onChange)="alterarExtraordinario()" label="Excepcional">
                <ng-template pTemplate="icon">
                    <span class="fas fa-check"></span>
                </ng-template>
            </p-checkbox>
        </div>
    </div>

    <div class="row mt-4">
        <div class="col text-right">
            <button type="button" class="secondary mr-2 botao-responsivo" pButton (click)="confirmarVoltar()">Voltar</button>
            <button type="submit" class="primary botao-responsivo" pButton>Concluir</button>
        </div>
    </div>
</form>

<p-confirmDialog key="confirmPadrao" acceptLabel="Sim" rejectLabel="Não"></p-confirmDialog>
